// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DateInput-module__wrapper___1iLhW","wrapperIsOpen":"DateInput-module__wrapperIsOpen___E7cRM","placeholderInput":"DateInput-module__placeholderInput___3VWL1"};